import { xboxExtension } from '@cbsinteractive/avia-js-xbox';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { AviaExtension } from 'tag/ts/tag/player/adapters/avia/extensions/AviaExtension';
import { IAviaExtension } from 'tag/ts/tag/player/adapters/avia/interfaces/IAviaExtension';

export class XboxCapabilitiesExtension extends AviaExtension implements IAviaExtension {
	package = xboxExtension;
	namespaceKey = 'plugin_xbox';

	constructor( argument: ITagAbstractClassArgument ) {
		super( {
			...argument,
			name: 'XboxCapabilitiesExtension'
		} );
	}

	shouldBeUsed() {
		if ( !super.shouldBeUsed() ) return false;

		const onXboxDevice = this.tag.params.SYSTEM.device === EmbedDevice.XBOX_ONE;
		const html5Embed = this?.params?.SYSTEM?.embedType === EmbedType.HTML5;

		if ( html5Embed && onXboxDevice ) {
			this?.logger?.log( 'onXboxDevice detected:', this.tag.params.SYSTEM.device );
		}

		return html5Embed && onXboxDevice;
	}
}